import type { ChangeEvent } from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
import Text from "@/components/forms/text";
import RadioGroup from "@/components/forms/radio-group";
import PostalCodeCity from "@/components/forms/postal-code-city";
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Plus, Trash2 } from 'lucide-react';
import { PictoVoirDetail } from '@/assets/icons-april-fr/pictos';

const Temoins = () => {
    const { control, watch, setValue } = useFormContext();
    const { fields, append, remove } = useFieldArray({ control, name: 'temoins' });

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setValue(name, value);
    };

    return (
        <Card className="mt-6">
            <CardHeader className="pb-6 border-b">
                <CardTitle className="text-lg flex items-center gap-2">
                    <PictoVoirDetail className="w-5 h-5" />
                    Témoin(s)
                </CardTitle>
            </CardHeader>
            <CardContent className="pt-6">
                <div className="space-y-6">
                    {fields.map((field, i) => (
                        <div key={field.id} className="space-y-5 p-6 bg-muted/30 rounded-lg">
                            <div className="flex items-center justify-between">
                                <p className="text-sm font-semibold">Témoin n°{i + 1}</p>
                                {fields.length === (i + 1) && (
                                    <Button variant="outline" size="sm" onClick={() => remove(i)} className="!border-destructive !text-destructive hover:!border-destructive/70 hover:!text-destructive/70 cursor-pointer">
                                        <Trash2 className="w-4 h-4" />
                                    </Button>
                                )}
                            </div>
                            <RadioGroup
                                label="Civilité"
                                name={`temoins.${i}.titre`}
                                setValue={setValue}
                                options={[{ value: "M", label: "Monsieur" }, { value: "Mme", label: "Madame" }]}
                                value={watch(`temoins.${i}.titre`)}
                            />
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                                <Text name={`temoins.${i}.nom`} onChange={handleChange} label="Nom" value={watch(`temoins.${i}.nom`)} normalize={v => v.toUpperCase()} />
                                <Text name={`temoins.${i}.prenom`} onChange={handleChange} label="Prénom" value={watch(`temoins.${i}.prenom`)} normalize={v => v.toUpperCase()} />
                                <Text name={`temoins.${i}.portable`} onChange={handleChange} label="Téléphone" value={watch(`temoins.${i}.portable`)} type="tel" />
                                <Text name={`temoins.${i}.adresse1`} onChange={handleChange} label="Adresse" value={watch(`temoins.${i}.adresse1`)} normalize={v => v.toUpperCase()} />
                                <PostalCodeCity label="Ville de résidence" cp={`temoins.${i}.cp`} ville={`temoins.${i}.ville`} />
                            </div>
                        </div>
                    ))}
                    <Button variant="outline" onClick={() => append({})} className="cursor-pointer">
                        <Plus className="w-4 h-4" />
                        Ajouter un témoin
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
};

export default Temoins;
